import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const putNewClubWorkflowOverrideData = (childOrgUnitId, parentOrgUnitId, offeringInstanceId, state, setState) => {
    if (childOrgUnitId.length > 0 && parentOrgUnitId.length > 0 ){
      const api = initApi(API_NAMES.CLUB, state, setState);
      const childOrgUnitIdForUrl = encodeURIComponent(childOrgUnitId);
      const parentOrgUnitIdForUrl = encodeURIComponent(parentOrgUnitId);

      const url = `/UsasClub/${childOrgUnitIdForUrl}/NewClubWorkflowOverride/lsc/${parentOrgUnitIdForUrl}/offering/${offeringInstanceId}`;
      return api?.executeObject ? api.executeObject(url, 'PUT') : null;
    }
  };

  const AdminOverridesData = { 
    putNewClubWorkflowOverrideData 
};

export default AdminOverridesData;